import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  SYSTEM_USERS_ADD_PATH,
  SYSTEM_USERS_PATH,
  SYSTEM_USERS_UPDATE_PATH,
} from "utils/constants/paths";

const SystemUsers = Loadable(React.lazy(() => import("./View")));
const SystemUsersAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const SystemUsersRoute: IRouteItem = {
  path: SYSTEM_USERS_PATH,
  iconName: "Profile2User",
  element: React.createElement(SystemUsers),
  name: "System Users",
  accessKeys: ["SuperAdmin", "Admin"],
  children: [
    {
      name: "Add / Update",
      path: SYSTEM_USERS_ADD_PATH,
      element: React.createElement(SystemUsersAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: SYSTEM_USERS_UPDATE_PATH,
      element: React.createElement(SystemUsersAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
